/*eslint-disable*/
import Rooms from "./pages/rooms";
import Bookings from "./pages/bookings";
import Profile from "./pages/profile";
import UserGames from "./pages/usergames";
import UserGropus from "./pages/usergroups";
import PublicGroupsUI from "./pages/groups";
import AdvertisingPage from "./pages/ads";

export const adminRoutes = [
    {
        path: "/users",
        component: <Rooms />,
    },
    {
        path: "/games",
        component: <Bookings />,
    },
     {
        path: "/groups",
        component: <UserGropus />,
    },
    {
        path: "/ads",
        component: <AdvertisingPage />,
    },
]

export const userRoutes = [
    {
        path: "/profile",
        component: <Profile />,
    },
    {
        path: "/user-games",
        component: <UserGames />
    },
    {
        path: "/user-groups",
        component: <PublicGroupsUI />
    }
]